import { EventImpl } from '@fullcalendar/core/internal';
import { FullAgentEventRequestEntry, OpenHouseEvent } from './app.models';
import { AlgoliaHit } from './constants/algolia';

import type { Moment } from 'moment-timezone';

export type WithId<T> = T & { id: string };

export type DateWithTimezone = Moment & { __brand: 'DateWithTimezone' };

export enum Roles {
  lender = 'lender',
  agent = 'agent',
  agentAdmin = 'agentAdmin',
}

export enum OpenHouseEventStatus {
  free = 'free',
  assigned = 'assigned',
}

export type EventApiTyped = Omit<EventImpl, 'extendedProps'> & {
  extendedProps?: OpenHouseEvent;
};

export interface AdminOpenHouseModalData {
  // Always present
  status: OpenHouseEventStatus;

  start: DateWithTimezone;
  end: DateWithTimezone;

  listingAddress: string;
  internalNote: string;

  // Present on existing events
  eventId?: string;
  requiresApproval?: boolean;
  agentRequests?: FullAgentEventRequestEntry[];

  // Present on assigned events
  agent?: AlgoliaHit;
  agentImageURL?: string;
  agentAvatarName?: string;

  assignEventFn?: (selectedAgentId: string) => Promise<{
    status: OpenHouseEventStatus;
    agent: AlgoliaHit;
    agentId: string;
    agentAvatarName: string;
    agentImageURL: string;
    agentListingId: string;
  }>;
}

export interface AgentOpenHouseModalData {
  eventId: string;

  status: OpenHouseEventStatus;
  agent: AlgoliaHit;

  start: DateWithTimezone;
  end: DateWithTimezone;

  internalNote: string;
  requiresApproval: boolean;
  didAgentRequestEvent: boolean;

  listingAddress: string;
  formattedShortDate: string;

  // Present on assigned events
  agentImageURL?: string;
  agentAvatarName?: string;
}

export type AdminOpenHouseModalOutput = AdminOpenHouseModalData & { action: 'create' | 'update' | 'delete' };
export type AgentOpenHouseModalOutput = { action: 'request' };

export interface CreateUpdateEventPayload {
  eventId: string;
  start: number;
  end: number;
  status: OpenHouseEventStatus;
  requiresApproval: boolean;
  internalNote: string;
  listingId: string;
  agentId?: string;
}